/**
 * Dieses Modul stellt die Client-API für die Reserva Engine zur Verfügung.
 */

var Promise = require('promise-polyfill');
var ajax = require('ajax');

/**
 * Ergebnis einer Suchanfrage. Wird von der exportierten Funktion des Moduls erzeugt.
 * 
 * @param params {Object} Request-Parameter
 * @param response {Object} Rückgabe vom Server
 */
var TraminoEngineResult = function(params, response) {
	this.params = params;
	this.response = response;

	if ( !response || !response.cache ) {
		var e = new Error("Invalid response from engine API");
		Raven.captureException(e, {
			extra: {
				param: params,
				response: response,
			}
		});
		throw e;
	}

	this.more_results = response.cache.count > 0;
	this.results_count = response.results.length;
	this.initial_results_count = response.results.length;
	this.start_time = (new Date()).getTime();
	this.more_count = 0;
};

/**
 * Liste aller Suchergebnisse zurück geben + Liste leeren
 */
TraminoEngineResult.prototype.getInitialResults = function() {
	var results = this.response.results;
	this.response.results = null;
	return results;
};

/**
 * Mehr Ergebnisse vom Server abfragen.
 *
 * @return {Promise} Gibt die Liste der NEUEN Ergebnisse zurück
 */
TraminoEngineResult.prototype.loadMore = function() {
	if ( !this.more_results ) return Promise.resolve([]);

	var url = this.response.refs.results + '&nocache=' + (new Date).getTime();
	return ajax(url).then(function(response) {
		this.more_results = response.cache.count > 0;
		this.results_count += response.results.length;
		this.more_count++;

		console.log("[ReservaEngineClient] Loaded " + this.results_count + " / " + this.response.count + " results");

		if ( !this.more_results && this.results_count != this.response.count ) {
			Raven.captureMessage("ResultMismatch", {
				extra: {
					firstResponse: {
						cache: this.response.cache,
						resultsLength: this.initial_results_count,
						totalResults: this.response.count,
					},
					lastResponse: {
						cache: response.cache,
						resultsLength: response.results.length,
					},
					state: {
						resultsCount: this.results_count,
						moreCount: this.more_count,
					},
					query: this.params,
					timeSinceStart: (new Date()).getTime() - this.start_time,
				},
			});
		}

		return response.results;
	}.bind(this));
};


/**
 * Suche ausführen
 *
 * @param params {Object} Suchparameter
 * @return {Promise} Gibt ein TraminoEngineResult zurück
 */
module.exports = {
	TraminoEngineResult: TraminoEngineResult,

	search: function(params) {
		params.cache = 0; // @todo Temporary until double render fix. 23.12.2016
		return ajax({
			method: 'GET',
			url: '/api/engine/',
			params: params,
		}).then(function(response) {
			if ( response.status && response.status === "error" ) {
				throw new Error("Fehler bei der Suche: " + response.message);
			}

			return new TraminoEngineResult(params, response);
		});
	},
};



/** WEBPACK FOOTER **
 ** /Users/mitch/jsapps/modules/reserva/engine/ReservaEngineClient.js
 **/